<template>
 <div class="d-flex flex-column full-screen-active">
		<header id="darkModeHeader" class="mdc-top-app-bar darkModeHeader">
				<div class="d-flex align-items-center pdl-30 pdr-30 justify-conetent-between h-full">
						<div
								class="t-subtitle3 t-color-whiteHigh  d-flex align-items-center pdr-24 font-r t-line-1 mgr-30">
								 {{ lessonName }}
						</div>
						<div class="d-flex align-items-center justify-content-end flex-grow-1">
								<div class="position-relative w-80 mgr-24">
										<div class="percentage-wrapper">
												<div class="h-2 position-relative total-percentage  bg-whiteBorder h-4">
														<div :style="{width: rate+'%'}"
																class="real-percentage bg-saleLine b-radius0 h-4 mgt-2">
														</div>
												</div>
										</div>
								</div>

								<div class="d-flex align-items-baseline mgr-24 t-nowrap">
										<div
												class="t-headline10 t-color-whiteHigh t-line-h-15 d-flex align-items-center  font-b">
												{{rate}}
										</div>
										<div class="t-body3 font-m mgl-4 t-color-whiteHigh">%</div>
								</div>

								<button
											@click="moveLearnViewClose()" @keypress="moveLearnViewClose()" tabindex="0"
										class="mdc-button mdc-button--outlined mdc-button--raised t-color-secondaryBtnText videoHeaderBtn b-radius4  pdl-12 pdr-12">
										<span class="mdc-button__ripple"></span>
										<span class="mdc-button__label t-body2 font-r t-color-whiteHigh t-nowrap">{{ $t('3182') }}</span>
								</button>
						</div>
				</div>
				<div v-if="lightModeActive" class="divider"></div>
		</header>
		
			<div :class="{
						'width-learning-object':isLearningObjective,
						'width-learning-material':isResources,
						'width-slide-chat':isQuestionAns
				}"
				class="d-flex slide-slider bg-contentPlayerBg" >

				<swiper
					ref="mySwiper"
					:options="swiperOption"
					class="gallery-top"
					@slideChange="changeSwiperIndex"
				>
					<swiper-slide
						v-for="(links, k) in linkUrl"
						:key="k"
						class="html-slide"
					>
						<iframe
							:id="`iframe_${k}`"
							:src="links"
							frameborder="0"
							height="100%"
							scrolling="0"
							title="description"
							width="100%"
						></iframe>
					</swiper-slide>

				</swiper>

				
			</div>
	
				<div v-if="isLearningObjective" :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'"  class="description-sidebar-slide t-color-white">
			<div :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'" class="pdt-27 pdb-26 pdl-24 pdr-24 sidebarHeader-slide position-relative">
					<div class="position-abosolute d-flex justify-content-between align-items-center ">
							<div class="t-subtitle3 font-m paging" :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'">{{  $t('1046') }}</div>
							<div class="d-flex align-items-center"><a href="javascript:void(0)"
											class="closebtn pdt-4" :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'" onclick="closeNav()"><i
													class="material-icons w-22 " @click="setisLearningObjective" @keypress="setisLearningObjective" tabindex="0">close</i></a></div>
					</div>
			</div>
			<div class="pdl-24 pdr-24 t-color-whiteHigh2 font-r t-body1 t-line-h-28 pdt-20">
							<span class="pdb-32">{{ learnPurposes }}</span>
					</div>
		</div>
		
		
		 <div v-if="isResources" :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'" class="learning-material-sidebar t-color-white" >
				<div :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'" class="pdt-27 pdb-27 pdr-24 pdl-24 sidebarHeader-slide position-relative">
						<div class="position-abosolute d-flex justify-content-between align-items-center ">
								<div class="t-subtitle3 font-m paging" :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'">{{$t('3186')}}</div>
								<div class="d-flex align-items-center"><a href="javascript:void(0)"
												class="closebtn pdt-4" :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'" @click="setisResources" @keypress="setisResources" tabindex="0"><i
														class="material-icons w-22 ">close</i></a></div>
						</div>
				</div>
				<div v-if="lessonData && lessonData.learningMaterials && lessonData.learningMaterials.length > 0"  class="mgt-8 pdl-24 pdr-24" >
								<div
										class="d-flex align-items-center justify-content-between pdt-4 pdb-4 bg-whiteHover b-whiteBorder b-radius4 mgb-16">
										<div class="d-flex align-items-center flex-grow-1 mgl-24">
												<button
														class="material-icons mdc-icon-button t-color-secondaryBtnText mgl--12">attach_file</button>
												<span class="t-color-whiteHigh t-body1 font-rn pdl-20">{{ lesson.learningMaterials[0].file.originalName }}</span>
										</div>
										<div>
												<button
														class="material-icons mdc-icon-button t-color-iconInactiveText mgr-12" @click="donwloadFile(lesson.learningMaterials[0])" @keypress="donwloadFile(lesson.learningMaterials[0])" tabindex="0">download</button>
										</div>
								</div>
				</div>
		</div>

	 
		<question-ans 
				v-if="isQuestionAns"
				:chatType ="'learn'"
				:isQuestionAns="isQuestionAns"
				:islightModeActive = "lightModeActive"
				:learnId="this.$route.params.learnId"
				:lessonId="this.$route.params.lessonId"
				@setisQuestionAnsHandler="setisQuestionAns"                  
		></question-ans>


			<div class="slider-footer">
					<!-- <div class="range-slider range-slider__range"> -->
							<!-- <input class="range-slider__range video-status w-full position-absolute" type="range"
									value="100" min="0" max="500"> -->
							<!-- <div :style="`width:${progressBar}%;`" class="home-progressbar video-status position-absolute"></div> -->
					<!-- </div> -->
					<div  class="divider-white divider-subtabs "></div>
					<div :class="lightModeActive ? '':'bg-contentPlayerBg'" class="d-flex justify-content-between  footer-learning">
							<div class="pdl-50 pdt-4 d-flex align-items-center">
									<span tabindex="0" @click="darkModeToLight()" @keypress="darkModeToLight()"><img  :src="lightModeActive?'/img/lightModeFixedButton.png':'/img/darkModeFixedButton.svg'" alt="theme toggle" class="cursor-pointer w-32 h-32"></span>
							</div>
							<div class="d-flex pdt-4 align-items-center justify-content-end mgr-50">
									<div class="d-flex align-items-center">
											<button
												@click="onLike" @keypress="onLike" tabindex="0"
												:class="likes ? 't-color-red' : 't-color-whiteDisabled'"
													class="material-icons mdc-icon-button l-icon mgl--12 ">favorite</button>
											<span class="t-body6 t-color-whiteHigh font-rn pdl-8">{{ likesCount }}</span>
									</div>
									<div class="d-flex align-items-center mgl-24 mgr-24">
											<button
												@click="onBookmark" @keypress="onBookmark" tabindex="0"
												:class="clipping ? 't-color-contentBlue' : 't-color-whiteDisabled'"
													class="material-icons mdc-icon-button l-icon mgl--12 ">bookmark</button>
											<span class="t-body6 t-color-whiteHigh font-rn pdl-8">{{ clippingCount }}</span>
									</div>
									<span class="cursor-pointer"><img :src="lightModeActive ? '/img/information-light.png': '/img/information.png'" alt="information" class="l-icon mgr-24" tabindex="0" @click="setisLearningObjective" @keypress="setisLearningObjective" ></span>
									<!-- <span><img src="/img/download.png" alt="" class="l-icon mgr-24" @click="setisResources" ></span> -->
									<button class="mdc-button  t-color-contentText min-w-auto mdc-button--raised" :class=" lightModeActive  ? 'bg-contentPlayerBgLight' : 'bg-secondaryBtn'" tabindex="0" @click="setisQuestionAns" @keypress="setisQuestionAns" >
											<div class="mdc-button__ripple"></div>
											<span class="mdc-button__label t-body2 font-r">{{$t('3184')}}</span>
									</button>
							</div>

					</div>
			</div>
	</div>
</template>


<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import htmlvideo from "@/json/htmlvideo.json";
import learnApi from "@/api/learnApi.js";
import LessonsList from "./LessonsListHtml.vue";
import { htmlTypeMixins } from "../../mixins/htmlType.js";
import {MDCRipple} from '@material/ripple'
import questionAns from '../questionContent/List.vue'
import localStorageUtil from "@/utils/localStorageUtil";


export default {
	data() {
		return {
			linkUrls: [],
			linkUrl: "",
			lessonData: null,
			lessonName: "",
			lessonsList: [],
			slideFiles: [],
			nextLessonName: "",
			currentProgressionId: "",
			rate: 0,
			last: 0,
			recent: 0,
			time: 0,
			countFile: 0,
			currentSlide: 0,
			showLectureList: false,
			staticPageStatus: true,

			// 북마크 좋아요 관려 데이터(like & bookmark data)
			isLiked: false,
			isBookmarked: false,
			likes: false,
			likesCount: 0,
			clipping: false,
			clippingCount: 0,

			isAllPages: false,
			isScroll: false,
			isTimeline: false,
			isExpand: false,
			myJson: htmlvideo,
			swiperOption:{},
			
			currentSliderIndex: 0,
			startIndex: 0,
			startTime: 0,
			enablNext: false,
			heartcolor: { color: "#758191" },
			bookMarkColor: { color: "#758191" },
			personalInfo:null,
			addOpacityClass: false,

			isQuestionAns:false,
			isLearningObjective:false,
			isResources:false,
			isNextLession:false,
			learnPurposes: '',
			slideSwiper:null,

			progressBar:0,
			lightModeActive:false

		};
	},
	watch: {
		setSlideNumber() {
			this.mySwiper.slideTo(this.setSlideNumber - 1);
		},
	},
	components: {
		swiper,
		swiperSlide,
		"lessons-list": LessonsList,
		'question-ans':questionAns
	},
	// mixins: [htmlTypeMixins],
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper;
		},
	},
	mounted() {
			const article = document.querySelector('html');
			const modeContent = article.getAttribute("data-theme");
			if(localStorage.getItem('themeMode')){
				article.setAttribute("data-theme", localStorage.getItem('themeMode'));
				this.lightModeActive = localStorage.getItem('themeMode') == 'dark' ? false : true;
			}
			else{
				if(modeContent == "dark")
					this.lightModeActive = false;
				else
					this.lightModeActive = true;
			}
		let paramsObj = {
						learnId: this.$route.params.learnId,
						progressionId: this.$route.params.progressionId
				};
		// set learn lesson object

		learnApi.openNextLearning(this.$route.params.learnId)
        	.then(() => {
				learnApi.learnLessonObjective(paramsObj).then((response) => {
						let responseData = response.data.data
						this.teacherName = responseData.teacher?responseData.teacher.fullName:''
						this.learnPurposes = this.getLearnPurposes(responseData.learnInfo)
				})
			})
			.catch((err) => {
				console.log("ERROR OPEN NEXT LEARNING API : ", err);
			});
		
		this.slideSwiper = this.$refs.mySwiper.swiper
		$(".video").click(function () {
			this.paused ? this.play() : this.pause();
		});
		$(".video-list-item").click(function () {
			$(this).addClass("active").siblings().removeClass("active");
		});
		$("#list-toggler").click(function () {
			$("#video-list").show().addClass("showList");
		});
		$("#listRemove").click(function () {
			$("#video-list").hide().removeClass("showList");
		});
		let params = this.setParams();
		let responseData = null;
		
		//차시 컨텐츠 정보 API 호출(get lesson contents data)
		this.$showLoading();
		learnApi
			.learnLessonContents(params)
			.then((response) => {
				responseData = response.data.data;
				this.lessonData = responseData;
				this.lessonName = this.lessonData.lessonName;
				this.rate = this.lessonData.rate;
				this.slideFiles = this.lessonData.html.files.filter((url) =>!url.includes("__MACOSX") );
				
				this.linkUrl = this.lessonData.html.files.filter((url) =>!url.includes("__MACOSX") );
				this.countFile = this.lessonData.html.count;
			 
				this.last = this.lessonData.last;
				this.recent = this.lessonData.recent;
				this.currentProgressionId = this.lessonData.progressionId;

				this.likes = this.lessonData.likes;

				this.likesCount = this.lessonData.likesCount;
				this.clipping = this.lessonData.clipping;

				this.clippingCount = this.lessonData.clippingCount;
				
				this.updateProgress();
				this.$hideLoading();
			})
			.catch((err) => {});
			learnApi.learnLessonTimelinecontents(params).then((response) => {
						responseData = response.data.data
						this.timelineContents = responseData
				}).catch((err) => {})

				learnApi.getMemberInfo().then((response)=>{
						this.personalInfo = response.data.data
				})
		this.fetchLectureList();
		this.setMaterialUi()
		if(typeof(this.$route.query.questionChatType) !='undefined'){
			this.setisQuestionAns()
		}
	},

	methods: {
		// set light and dark mode
		darkModeToLight(){
			const article = document.querySelector('html');
			const modeContent = article.getAttribute("data-theme");
			localStorage.setItem('themeMode', modeContent == "dark" ? "light" : "dark");
			article.setAttribute("data-theme", modeContent == "dark" ? "light" : "dark");
			this.lightModeActive = !this.lightModeActive;
		},
		// set toggle question and answer
		setisQuestionAns(){
				this.isQuestionAns = !this.isQuestionAns;
				 this.isLearningObjective = false;
				 this.isResources = false;
		},
		// set toggle learning
		setisLearningObjective(){
				this.isResources = false;
				this.isQuestionAns = false;
				this.isLearningObjective = !this.isLearningObjective;
		},
		// set toggle resource
		setisResources(){
				this.isLearningObjective = false;
				this.isQuestionAns = false;
				this.isResources = !this.isResources;
		},
		// progress status
		updateProgressWithOneHtml() {
			let params = {
				total: this.countFile,
				current: this.currentSliderIndex+1,
				learnId: this.$route.params.learnId,
				progressionId: this.$route.params.progressionId,
			};

			let progressBarLength = Math.floor(params.current*100/params.total)
			if(parseInt(progressBarLength)){
				this.progressBar = progressBarLength;
			} else {
				this.progressBar = 0;
			}

			let responseData = null;

			if(this.countFile === parseInt(this.currentSliderIndex + 1)) {
					this.addOpacityClass  = true
			} else {
					this.addOpacityClass  = false
			}

			learnApi
				.learnLessonProgression(params)
				.then((response) => {
					responseData = response.data.data;
					this.rate = responseData.rate;
					this.last = responseData.last;
				})
				.catch((err) => {});
		},
		// close 
		moveLearnViewClose() {
						
				let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
				let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
				if(goBackBookMarkLessson == 'setVideoBookMarkLesson'){
						localStorage.removeItem('videoBookMarkLesson');
						this.$router.push({
								name: 'BookMarkedLesson' 
						})
				}else if(goBackLikeLessson=='setVideoLikeLesson'){
						localStorage.removeItem('videoLikeLesson');
						this.$router.push({
								name: 'LikedLesson' 
						})
				}else if(typeof(this.$route.query.questionChatType) !='undefined'){
					this.$router.push({
					name: 'LearnView', 
					params: {learnId: this.$route.params.learnId},
					query: {status:this.$route.query.status,tab:'ViewQuestion'}
					})
				}else{
						this.$router.push({
						name: 'LearnView', 
						params: {learnId: this.$route.params.learnId},
						query: this.$route.query
						})
				}

						
				},
				takeSurvey(id,respondentId,surveyDistributionType){
						 let params = {
								distId: id,
								respondentId: respondentId,
						}
						
						this.$router.push({
								name: 'IndependentSurveyIntro',
								params: params,
								query:{status:this.$route.query.status,learnId:this.$router.currentRoute.params.learnId,distributionType:surveyDistributionType}
						})
				},
		// scroll html
		getSwiperData() {
			this.staticPageStatus = false;
			this.slideSwiper = this.$refs.mySwiper.swiper;
			this.startIndex = this.recent ? this.recent - 1 : 0;
			
			this.countFile===1 ? this.updateProgressWithOneHtml():this.updateProgressWithOneHtml();
			
			if (this.startIndex > 0 && this.startIndex < this.slideFiles.length - 1) {
				this.$confirm({
					title: this.$t("173"), // '학습 중인 강의입니다.',
					content: this.$t("174") + "<br>" + this.$t("175"), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
					accept: this.$t("177"), //'이어서 보기',
					cancel: this.$t("176"), //'처음부터 보기',
				})
					.then(() => {
						
						this.$refs.mySwiper.swiper.slideTo(this.startIndex);
					})
					.catch(() => {
						this.$refs.mySwiper.swiper.slideTo(0);
					});
			} else {
				this.$refs.mySwiper.swiper.slideTo(0);
			}

			// 첫페이지 진도저장 실행(first load save progress)
			this.$emit("updateProgress");

			if (this.time > 0 && this.startIndex + 1 > this.last) {
				this.runTimer(this.startIndex);
			} else {
				this.enablNext = true;
			}

			this.$refs.mySwiper.swiper.allowSlideNext = this.enablNext;

			if (this.contentsType != "PDF") {
				this.$refs.mySwiper.swiper.on("slideChange", () => {
					let activeIndex = this.$refs.mySwiper.swiper.activeIndex;
					this.runTimer(activeIndex);
					this.$emit("updateProgress", activeIndex);
				});
			}

			this.$refs.mySwiper.swiper.on("touchStart", () => {
				if (
					this.enablNext === true &&
					this.slideFiles.length - 1 === this.$refs.mySwiper.swiper.activeIndex
				) {
					this.$emit("updateEndedLesson", true);
				} else {
					this.$emit("updateEndedLesson", false);
				}
			});
		},
		runTimer(activeIndex) {
			if (this.last < activeIndex + 1) {
				this.enablNext = false;
				this.startTime = this.time;
				this.setTimer();
			}
		},
		// 슬라이드 타이머 동작(Slide timer action)
		setTimer() {
			this.startTime--;
			if (this.startTime > 0) {
				setTimeout(() => {

					this.setTimer();
				}, 1000);
			} else {
				this.enablNext = true;
			}
		},
		// curent index
		changeSwiperIndex() {
			this.currentSliderIndex = this.$refs.mySwiper.swiper.realIndex;
			if(this.countFile === parseInt(this.currentSliderIndex + 1)) {
					this.addOpacityClass  = true
			} else {
					this.addOpacityClass  = false
			}

			let progressBarLength
			progressBarLength = Math.floor(params.current*100/params.total);
			
			if(parseInt(progressBarLength)) {
				this.progressBar = progressBarLength;
			} else {
				this.progressBar = 0;
			}

			let params = {
				total: this.countFile,
				current: this.currentSliderIndex + 1,
				learnId: this.$route.params.learnId,
				progressionId: this.$route.params.progressionId,
			};
			learnApi
				.learnLessonProgression(params)
				.then((response) => {
					let responseData = response.data.data;
					this.rate = responseData.rate;
					this.last = responseData.last;
				})
				.catch((err) => {});
		},

		getLinkUrl(links) {
			let url = this.linkUrls.find(
				(str) => parseInt(str.split("/").pop().replace(/[^\d]/g, "")) == links
			);

			
			return url || null;
		},
		// 진도저장 API 호출(update progress)
		updateProgress() {

			let params = this.setParams();
			let responseData = null;

			let progressBarLength = Math.floor(params.current*100/params.total)
			if(parseInt(progressBarLength)){
				this.progressBar = progressBarLength;
			} else {
				this.progressBar = 0;
			}

			learnApi
				.learnLessonProgression(params)
				.then((response) => {
					responseData = response.data.data;
					this.rate = responseData.rate;
					this.last = responseData.last;
				})
				.catch((err) => {});
		},

		
		// API 파라미터 설정(set parameter)
		setParams() {
			let params = {
				total: this.countFile,
				//current: this.currentSliderIndex,
				current: 1,
				learnId: this.$route.params.learnId,
				progressionId: this.$route.params.progressionId,
			};
			return params;
		},
		fetchLectureList() {
			let responseData = null;
			let params = this.setParams();

			//차시 정보
			learnApi
				.learnViewCourses(params)
				.then((response) => {
					// 과정의 차시 정보만 병합(Merging only lesson data from the course)
					_.each(response.data.data, (course) => {
						this.lessonsList = this.lessonsList.concat(course.lessons);
					});

					// 다음 차시명 설정(set next lesson)
					let currentLessonIndex = _.findIndex(this.lessonsList, (lesson) => {
						return lesson.progressionId === this.currentProgressionId;
					});
					let nextLessonIndex =
						this.lessonsList.length > 1 &&
						this.lessonsList.length > currentLessonIndex
							? (currentLessonIndex += 1)
							: -1;

					if (nextLessonIndex) {
						this.nextLesson = this.lessonsList[nextLessonIndex]
						if(nextLessonIndex === -1){
								this.nextLessonName = this.$t('1999')
						} else {
								if (typeof(this.lessonsList[nextLessonIndex]) != "undefined"){
										this.nextLessonName = this.lessonsList[nextLessonIndex].name
								} else {
										this.nextLessonName = this.$t('1999')
								}   
								
						}
					}  
				})
				.catch((err) => {});
		},
		// set parameter
		setLikeAndBookParams() {
			let params = {
				learnId: this.$route.params.learnId,
				progressionId: this.$route.params.progressionId,
			};
			return params;
		},
		// set like and dislike 
		onLike() {
			let params = this.setLikeAndBookParams();
			let responseData = null;
			if (this.likes) {
				learnApi
					.learnLessonLikesDelete(params)
					.then((response) => {
						responseData = response.data.data;
						//this.heartcolor={'color':'#758191 !important'}
						this.likes = response.data.data;
						this.likesCount = this.likesCount - 1;
					})
					.catch((err) => {});
			} else {
				learnApi
					.learnLessonLikesPost(params)
					.then((response) => {
						//this.heartcolor={'color':'var(--secondaryBtnText) !important'}
						responseData = response.data.data;
						this.likes = response.data.data;

						this.likesCount = this.likesCount + 1;

					})
					.catch((err) => {});
			}
		},

		// 북마크 API 호출(set/cancel bookmark)
		onBookmark() {
			let params = this.setParams();
			let responseData = null;
			if (this.clipping) {
				learnApi
					.learnLessonClippingDelete(params)
					.then((response) => {
						responseData = response.data.data;
						this.clipping = responseData;
						//this.bookMarkColor={'color':'#758191 !important'}
						this.clippingCount = this.clippingCount - 1;

						this.toggleBookmarkIcon();
					})
					.catch((err) => {});
			} else {
				learnApi
					.learnLessonClippingPost(params)
					.then((response) => {
						responseData = response.data.data;
						this.clipping = responseData;
						this.clippingCount = this.clippingCount + 1;
					})
					.catch((err) => {});
			}
		},
		// move to question
		moveQuestion() {
			this.$router.push({
				name: "LessonViewQuestion",
				query: this.$route.query,
			});
		},
		setMaterialUi() {
						const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
								let button = new MDCRipple.attachTo(el)
								return button
						})
				},
		// download
		donwloadFile(fileInfo) {
						let fileName = fileInfo.file.id ? fileInfo.file.originalName : fileInfo.split('/').pop()
						let resourceUri = fileInfo.file.id ? fileInfo.file.resourceUri : fileInfo

						httpService.fileDownload(resourceUri).then((response) => {                
								const url = window.URL.createObjectURL(new Blob([response.data]))
								const link = document.createElement('a')
								
								link.href = url
								link.setAttribute('download', fileName)
								document.body.appendChild(link)
								link.click()
						}).catch(() => {
								console.log('error occured')
						})
		},

		getLearnPurposes(obj) {
      const languageInfo = JSON.parse(localStorageUtil.getLanguageInfo());
      const learnInfo = obj.find(info => info.lang.value === languageInfo.code);
      return learnInfo ? learnInfo.summary : "";
		},
	},
};
</script>
<style scoped>
  .html-slide .swiper-slide .swiper-slide-active {
    width: 100% !important;
  }

	.home-progressbar {
				position: absolute;
				height: 4px;
				background: var(--Saleline);
				
		}
	/* .swiper-slide{
		height: calc(100% - 64px);
	} */
	/* .slide-slider .swiper-button-next,
				.slide-slider .swiper-container-rtl .swiper-button-prev {
						right: 0;
						left: auto;
						height: calc(100% - 180px);
						top: 90px;
						width: 110px;
				} */
html[dir="rtl"] .slide-slider .swiper-button-next,
				html[dir="rtl"] .slide-slider .swiper-container-rtl .swiper-button-prev {
						right: 0;
						left: auto;
				}

				.slide-slider .swiper-button-prev,
				.slide-slider .swiper-container-rtl .swiper-button-next {
						left: 0;
						right: auto;
						height: calc(100% - 180px);
						top: 90px;
						width: 110px;
				}
				html[dir="rtl"] .slide-slider .swiper-button-prev,
				html[dir="rtl"] .slide-slider .swiper-container-rtl .swiper-button-next {
						right: 0;
						left: auto;
						height: calc(100% - 180px);
						top: 90px;
						width: 110px;
				} 
</style>

